import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRootTokenSearch = 'Tools|Fulfillment Vouchers|Token Search';

export type SPFulfillmentVoucherTokenSearchDialogLocs =
	| 'SPFulfillmentVoucherTokenSearchDialogTitle'
	| 'SPFulfillmentVoucherTokenSearchDialogTokenIdLabel'
	| 'SPFulfillmentVoucherTokenSearchDialogTokenIdRequired'
	| 'SPFulfillmentVoucherTokenSearchDialogSearchButton'
	| 'SPFulfillmentVoucherTokenSearchDialogCloseButton'
	| 'SPFulfillmentVoucherTokenSearchDialogResultsTitle'
	| 'SPFulfillmentVoucherTokenSearchDialogBatchId'
	| 'SPFulfillmentVoucherTokenSearchDialogRequirement'
	| 'SPFulfillmentVoucherTokenSearchDialogExpirationDate'
	| 'SPFulfillmentVoucherTokenSearchDialogRedeemedOn'
	| 'SPFulfillmentVoucherTokenSearchDialogRedeemedBy'
	| 'SPFulfillmentVoucherTokenSearchDialogStatus'
	| 'SPFulfillmentVoucherTokenSearchDialogRevokeButton'
	| 'SPFulfillmentVoucherTokenSearchDialogRevokeError'
	| 'SPFulfillmentVoucherTokenSearchDialogTokenNotFound'
	| 'SPFulfillmentVoucherTokenSearchDialogRevokeSuccess';

export const spFulfillmentVoucherTokenSearchDialogLocDefs: LocDefs<SPFulfillmentVoucherTokenSearchDialogLocs> =
	{
		SPFulfillmentVoucherTokenSearchDialogTitle: {
			defaultValue: 'Search Token',
			description: 'Title for the fulfillment voucher token search dialog.',
			displayPath: `${dpRootTokenSearch}|Title`,
			displayType: 'Title',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogTokenIdLabel: {
			defaultValue: 'Token ID',
			description: 'Label for the token ID input field.',
			displayPath: `${dpRootTokenSearch}|Token ID Label`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogTokenIdRequired: {
			defaultValue: 'Token ID is required.',
			description: 'Error message when token ID is required.',
			displayPath: `${dpRootTokenSearch}|Token ID Required`,
			displayType: 'Error',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogSearchButton: {
			defaultValue: 'Search',
			description: 'Button text to search for a token.',
			displayPath: `${dpRootTokenSearch}|Search Button`,
			displayType: 'Button',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogCloseButton: {
			defaultValue: 'Close',
			description: 'Button text to close the dialog.',
			displayPath: `${dpRootTokenSearch}|Close Button`,
			displayType: 'Button',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogResultsTitle: {
			defaultValue: 'Voucher Details',
			description: 'Title for the search results section.',
			displayPath: `${dpRootTokenSearch}|Results Title`,
			displayType: 'Title',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogBatchId: {
			defaultValue: 'Batch ID',
			description: 'Label for the batch ID field.',
			displayPath: `${dpRootTokenSearch}|Batch ID`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogRequirement: {
			defaultValue: 'Requirement',
			description: 'Label for the requirement field.',
			displayPath: `${dpRootTokenSearch}|Requirement`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogExpirationDate: {
			defaultValue: 'Expiration Date',
			description: 'Label for the expiration date field.',
			displayPath: `${dpRootTokenSearch}|Expiration Date`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogRedeemedOn: {
			defaultValue: 'Redeemed On',
			description: 'Label for the redeemed on field.',
			displayPath: `${dpRootTokenSearch}|Redeemed On`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogRedeemedBy: {
			defaultValue: 'Redeemed By',
			description: 'Label for the redeemed by field.',
			displayPath: `${dpRootTokenSearch}|Redeemed By`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogStatus: {
			defaultValue: 'Revoked',
			description: 'Label for the revoked field.',
			displayPath: `${dpRootTokenSearch}|Revoked`,
			displayType: 'Label',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogRevokeButton: {
			defaultValue: 'Revoke Token',
			description: 'Button text to revoke the token.',
			displayPath: `${dpRootTokenSearch}|Revoke Button`,
			displayType: 'Button',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogRevokeError: {
			defaultValue: 'Error revoking token.',
			description: 'Error message when revoking token fails.',
			displayPath: `${dpRootTokenSearch}|Revoke Error`,
			displayType: 'Error',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogTokenNotFound: {
			defaultValue: 'Token not found.',
			description: 'Error message when token is not found.',
			displayPath: `${dpRootTokenSearch}|Token Not Found`,
			displayType: 'Error',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
		SPFulfillmentVoucherTokenSearchDialogRevokeSuccess: {
			defaultValue: 'Token revoked successfully.',
			description: 'Success message when token is revoked.',
			displayPath: `${dpRootTokenSearch}|Revoke Success`,
			displayType: 'Notification',
			feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
			htmlAllowed: false,
			shared: false,
			portal: 'SP',
		},
	};

export const spFulfillmentVoucherTokenSearchDialogLocs =
	MapLocKeys<SPFulfillmentVoucherTokenSearchDialogLocs>(
		spFulfillmentVoucherTokenSearchDialogLocDefs
	);

export type SPFulfillmentVoucherTokenSearchDialogLocKeys =
	typeof spFulfillmentVoucherTokenSearchDialogLocs;
